module.exports = __webpack_public_path__ + "img/pomegranat-grapefruit.20a21bbf.png";